/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactScriptManifest } from './ContactScriptManifest.js';
import {
    ContactScriptManifestFromJSON,
    ContactScriptManifestFromJSONTyped,
    ContactScriptManifestToJSON,
} from './ContactScriptManifest.js';

/**
 * 
 * @export
 * @interface CreateContactScriptResponse
 */
export interface CreateContactScriptResponse {
    /**
     * 
     * @type {ContactScriptManifest}
     * @memberof CreateContactScriptResponse
     */
    data?: ContactScriptManifest;
    /**
     * 
     * @type {number}
     * @memberof CreateContactScriptResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateContactScriptResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateContactScriptResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof CreateContactScriptResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the CreateContactScriptResponse interface.
 */
export function instanceOfCreateContactScriptResponse(value: object): boolean {
    return true;
}

export function CreateContactScriptResponseFromJSON(json: any): CreateContactScriptResponse {
    return CreateContactScriptResponseFromJSONTyped(json, false);
}

export function CreateContactScriptResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateContactScriptResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ContactScriptManifestFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CreateContactScriptResponseToJSON(value?: CreateContactScriptResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ContactScriptManifestToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

